import { useEffect, useMemo, useState } from 'react';
import api from '../../libraries/api';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { useRestrictedContent } from '../../libraries/hooks';
import ForbiddenError from '../../components/Error/ForbiddenError/ForbiddenError';
import './ArticlesPrices.css';
import { t } from '../../libraries/i18n';
import { Article } from '@abm-international/react-components';
import { VIEWS } from '@abm-international/react-components';
import ProductDetail from '../PreOrders/ProductItem/ProductDetail';

const priceColumns = [
	{ key: 'arp_pr2', label: 'Prijs 2' },
	{ key: 'arp_pr3', label: 'Prijs 3' },
	{ key: 'arp_pr4', label: 'Prijs 4' },
	{ key: 'arp_pr5', label: 'Prijs 5' },
	{ key: 'arp_pr6', label: 'Prijs 6' },
];

export const ArticlePrices = (props: any) => {
	const [articles, setArticles] = useState<any[]>([]);
	const [loading, setLoading] = useState(true);
	const [search, setSearch] = useState('');
	const [visibleCols, setVisibleCols] = useState<{ [key: string]: boolean }>(
		priceColumns.reduce((acc, col) => ({ ...acc, [col.key]: false }), {})
	);
	const [RestrictedContent, RestrictedContentError] = useRestrictedContent(props.requiredPermission);

	function fetchArticles() {
		setLoading(true);
		return api.allArticlesWithAllPrices()
			.then(data => {
				setArticles(Object.values(data) || []);
				setLoading(false);
			})
			.catch(() => {
				setArticles([]);
				setLoading(false);
			});
	}
	useEffect(() => {
		fetchArticles();
	}, []);

	const filteredArticles = articles.filter(article => {
		const searchStr = search.trim().toLowerCase();
		if (!searchStr) return true;

		const id = String(article.id).toLowerCase();
		const name = String(article.name).toLowerCase();
		const brand = String(article.brand).toLowerCase();

		const combined = `${id} ${name}`;
		if (combined.includes(searchStr)) return true;
		const terms = searchStr.split(/\s+/).filter(Boolean);
		return terms.every(term => id.includes(term) || name.includes(term) || brand.includes(term));
	});
	const maxAmountOfRenderArticles = 250;
	const [showModal, setShowModal] = useState<Number| undefined|null>();

	return (
		<>
			<RestrictedContentError>
				<ForbiddenError permissionName={'Enkel voor vertegenwoordigers'} />
			</RestrictedContentError>
			<RestrictedContent>
				<div className="articles-prices-container">
					{loading ? (
						<div className="articles-prices-spinner">
							<div className="articles-prices-spinner-icon" />
						</div>
					) : (
						<>
							<input
								type="text"
								placeholder="Zoek product op id, naam of merk..."
								value={search}
								onChange={e => setSearch(e.target.value)}
								className="articles-prices-search"
							/>
							{showModal && (
								<>
									<div className="articles-prices-modal-overlay" style={{
										position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh', background: 'rgba(0,0,0,0.4)', zIndex: 2000
									}} />
									<div className="articles-prices-modal" style={{
										position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 2001,
										background: 'white', boxShadow: '0 4px 24px rgba(0,0,0,0.2)', borderRadius: '12px', padding: '2rem', minWidth: '350px', maxWidth: '90vw', maxHeight: '90vh', overflowY: 'auto', border: '1px solid #ccc'
									}}>
										<button
											style={{
												position: 'absolute', top: 16, right: 16, background: 'none', border: 'none', fontSize: '2rem', cursor: 'pointer', color: '#C1222F', zIndex: 2002
											}}
											onClick={() => setShowModal(undefined)}
											aria-label="Sluiten"
										>
											&#10005;
										</button>
										<ProductDetail product={{ ...filteredArticles.find(a => a.id === showModal), eob: false }} />
									</div>
								</>
							)}
							<div className="articles-prices-grid">
								<div className="articles-prices-header"></div>
								{priceColumns.map(col => (
									<div key={col.key} className="articles-prices-col-toggle"
										onClick={() => setVisibleCols(v => ({ ...v, [col.key]: !v[col.key] }))}
									>
										{visibleCols[col.key] ? <FaEye title="Verberg prijs" /> : <FaEyeSlash title="Toon prijs" />}
										{col.label}
									</div>
								))}
								{filteredArticles.slice(0, maxAmountOfRenderArticles).map(article => (
									<>
										<div key={`${article.id}-name`}>
											<Article
												product={article}
												t={t}
												view={VIEWS.COMPACT}
												locale={'nl'}
												imageSource={`${process.env.REACT_APP_PORTAL_IMAGE_URL}/resources/images/articles`}
											>
												{(A: any) => (
													<div className={`TradeFairArticle ${VIEWS.COMPACT}`}>
														<div className='left' onClick={() => setShowModal(article.id)}>
															<A.Image />
															<div className={'detail'}>
																<div className={'top'} style={{ alignItems: 'center' }}>
																	<A.Id /><A.Brand />
																	<div className={`Article__ABCAssortmentCode_${ article.abcAssortmentCode ?? ''}`}></div>
																</div>
																<div className={'middle'}>
																	<A.Name />
																</div>
																<A.Allergens
																	compact={true}
																	view={'list'}
																/>
															</div>
														</div>
													</div>
												)}
											</Article>
										</div>
										{priceColumns.map(col => (
											// <div key={`${article.id}-${col.key}`}>{visibleCols[col.key] ? `€ ${article.prices?.[col.key] ?? ''}` : ''}</div>
											<div
												key={`${article.id}-${col.key}`}
												style={!visibleCols[col.key] ? { filter: 'blur(6px)', opacity: 0.8 } : {}}
											>
												{`€ ${article.prices?.[col.key] ?? ''}`}
											</div>
										))}
									</>
								))}
								{filteredArticles.length > maxAmountOfRenderArticles && (
									<div className="articles-prices-warning" style={{ marginTop: '2rem', color: '#C1222F', fontWeight: 'bold' }}>
										Maximaal renders is {maxAmountOfRenderArticles} artikelen, gebruik de zoekbalk bovenaan om gericht een artikel te zoeken.
									</div>
								)}
							</div>
						</>
					)}
				</div>
			</RestrictedContent>
		</>
	);
};
